import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import {filterAutocomplete_template} from "./filterAutocomplete_template";
import {warningDialog_template} from "./warningDialog_template";
declare var ko: any;

export class articlePinnedTags_template extends vnTemplate{

    public filterTagType: filterAutocomplete_template;
    public filterTags: filterAutocomplete_template;
    public missingSpecDialog : warningDialog_template;
    protected styleTooltip: infoButton_template;
    protected optionTooltip: infoButton_template;
    protected selectTagTooltip: infoButton_template;
    protected selectTagTooltipContent: any;

    protected getTemplateHtml(): string{
        return `
               
                <strong class="form-sub-title pinned-tags">[DEPRECATED] Pinned Tags</strong>
                
                <div class="form-body no-margin">
                
                     <div class="form-group inside-label">
                        <label for="title" class="form-label">Title</label>
                        <input id="title" data-bind="attr :{readonly : isPublishingControl() || isGlobalLockEnabled() }, value: title, valueUpdate: 'keyup'" type="text" class="input-text">
                    </div>
               
                    <div class="form-group row">
                        <label for="type" class="form-label">Position</label>
                        <select name="" id="" data-bind="disable: isPublishingControl() || isGlobalLockEnabled() , value: position">
                            <option value="top">Top</option>
                            <option value="bottom">Bottom</option>
                        </select>
                    </div>
                    
                </div>
                
                <div class="form-body no-margin">
                          
                    <div class="form-group row">
                        <div style="display: flex">
                            <label for="type" class="form-label">Style</label>
                            <div class="w-tooltips-adv pos-top short" style="margin: 0 1.5rem 0 1rem">
                                ` + this.styleTooltip.getHtmlBuild() + `
                            </div>
                        </div>
                        
                        <select data-bind="options:styles, disable: isPublishingControl() || isGlobalLockEnabled(),
                            value: computedChosenStyle">
                        </select>
                    </div>
                
                    <div class="form-group" data-bind="visible: selectedStyle() == 'single-spec'">
                        <hr />
                    </div>

                    <div class="form-group" style="margin-bottom: 3rem;" data-bind="visible: selectedStyle() == 'single-spec'">
                        ${this.filterTagType.getHtmlBuild() }
                    </div>
                    

                    <div class="form-group row" style="margin-top: 5rem" data-bind="visible: isShownTagTypeSpec">
                        <div style="display: flex;">
                            <label class="form-label" style="white-space: nowrap">Spec Field</label>
                            <div class="w-tooltips-adv pos-top short" style="margin: 0 1.5rem 0 2.5rem">
                                ` + this.optionTooltip.getHtmlBuild() + `
                            </div>
                        </div>
                         <select data-bind="options:tagSpecs, disable: isPublishingControl() || isGlobalLockEnabled(),
                            optionsText:'name',
                            optionsValue: 'id',
                            value: computedChosenTagSpec">
                        </select>
                         
                    </div>
                    
                    <div class="form-group" data-bind="visible: (selectedStyle() == 'full-spec' || (selectedStyle() == 'single-spec' && isShownTagTypeSpec && selectedTagSpec()))">
                        <hr />
                    </div>
                        
                    <div class="form-group" data-bind="visible:(selectedStyle() == 'full-spec' ||(selectedStyle() == 'single-spec' && isShownTagTypeSpec() && selectedTagSpec()))">
                        <div class="w-tooltips-adv pos-top short" style="margin: 0 1.5rem 0 1.5rem;position: absolute;top: -5px; z-index: 10;left: 6.5rem;">
                             ` + this.selectTagTooltip.getHtmlBuild() + `
                         </div>
                        ${this.filterTags.getHtmlBuild() }
                        <div  data-bind="foreach: tags">
                            <div class="btn-selection"><span data-bind="text: $data.name"></span><button class="icon i-x-after" type="button" data-bind="event: { click: $parent.onClickDeleteTag.bind($parent) }"></button></div>
                        </div>
                    </div>
                
                    <div class="form-group">
                        ${this.missingSpecDialog.getHtmlBuild() }
                    </div>          
                </div>
            
             `;
    }

    protected initPartial(): void {

        this.filterTagType = new filterAutocomplete_template('filterAutocompleteTagTypeArticlePinnedTags_template', this.getTemplateViewModel(), this.caller);
        this.filterTagType.setPlaceholderAndLabel( 'Tag Type' );
        this.filterTagType.setOptionType("Tag Type");
        this.filterTagType.setAddNewOptionEnabled(false);
        // this.filterTagType.setHasInputClearConfirmPrompt(true);
        // this.filterTagType.setClearInputConfirmMessage('Updating the tag type will clear any selected specification fields and tags. Are you sure you want to continue?')

        this.filterTags = new filterAutocomplete_template("filterAutocompleteTagArticlePinnedTags_template", this.getTemplateViewModel(), this.caller);
        this.filterTags.setPlaceholderAndLabel('Tags' );
        this.filterTags.setOptionType("Tags");
        this.filterTags.setIsShowCurrentSelection(false);
        this.filterTags.setAddNewOptionEnabled(false);

        this.missingSpecDialog = new warningDialog_template('missingSpecDialog_template', this.getTemplateViewModel(), this.caller);
        this.missingSpecDialog.setTitle('Missing Spec');
        this.missingSpecDialog.setParent(this);

        this.styleTooltip = new infoButton_template('styleTooltip', this.getTemplateViewModel(), this.caller)
        this.styleTooltip.setTitle('Style Selection');
        let styleToolTipContent = `<p><strong>Single Spec</strong>: This will display a single specification field whenever a corresponding value for the selected field exists.</p>
                                    <p><strong>Full Spec</strong>: This will display all specifications fields that have a corresponding value.</p>`
        this.styleTooltip.setContent(styleToolTipContent);

        this.optionTooltip = new infoButton_template('optionTooltip', this.getTemplateViewModel(), this.caller)
        this.optionTooltip.setTitle('SPECIFICATION FIELD');
        let optionToolTipContent = `<p>A single specification field can be selected. If a selected tag does not contain a corresponding value for the specification field, it will not be displayed.</p>`
        this.optionTooltip.setContent(optionToolTipContent);

        this.selectTagTooltip = new infoButton_template('selectTagTooltip', this.getTemplateViewModel(), this.caller)
        this.selectTagTooltip.setTitle('Tag Selection');
        this.selectTagTooltipContent = {
            'single-spec': `<p>Any tags of the selected type can be used. The tag must have an associated image or at least one specification value. Only those marked with a green indicator are available for use by your brand.</p>
                            `,
            'full-spec': `<p>A tag must have an associated image or at least one specification value to be selected. Only those marked with a green indicator are available for use by your brand.</p>
                           `,
        };
        this.selectTagTooltip.setContent(this.selectTagTooltipContent[this.getTemplateViewModel().selectedStyle()]);
    }

    protected getTemplateName(): string{
        return "articlePinnedTags_template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string>{

        return ['w-form-body'];
    }

    protected buildViewModel(): any{

        let huit_neuf_this = this;
        return  {
             title: ko.observable("")
            ,position: ko.observable("")
            ,selectedStyle: ko.observable("")
            ,selectedTagSpec: ko.observable()
            ,tags: ko.observable([])
            ,isShownTagTypeSpec: ko.observable(false)
            ,styles: ko.observableArray(['single-spec','full-spec'])
            ,tagSpecs: ko.observableArray([])
            ,isPublishingControl : ko.observable(false)
            ,isGlobalLockEnabled : ko.observable(false)
            ,onClickCancel: function (data, event) { huit_neuf_this.onClickCancel() }
            ,onClickDeleteTag: function (data, event) { huit_neuf_this.onClickDeleteTag(data) }
            ,computedChosenStyle : ko.pureComputed({
                read: function () {
                    return huit_neuf_this.getTemplateViewModel().selectedStyle();
                },
                write: function (value) {
                    return this.onChangeStyle(value);
                },
                deferEvaluation: true,
                owner: this
            })
            ,computedChosenTagSpec : ko.pureComputed({
                read: function () {
                    return huit_neuf_this.getTemplateViewModel().selectedTagSpec();
                },
                write: function (value) {
                   return  this.onChangeTagSpec(value);
                },
                deferEvaluation: true,
                owner: this
            })
        };
    }

    public onClickCancel(){
        this.caller.onClickHidePinnedTagsForm(false);
    }

    public setTitle(title){
        this.getTemplateViewModel().title(title);
    }

    public setPosition(position){
        this.getTemplateViewModel().position(position);
    }

    public setSelectedStyle(selectedStyle){
        this.getTemplateViewModel().selectedStyle(selectedStyle);
    }

    public setSelectedTagSpec(selectedStyle){
        this.getTemplateViewModel().selectedTagSpec(selectedStyle);
    }

    public setTags(tags){
        this.getTemplateViewModel().tags(tags);
    }

    public setTagSpecs(specs){
        this.getTemplateViewModel().tagSpecs(specs);
    }

    public addTag(){

        let selectedTag = this.filterTags.getOptionObj();
        let tags = this.getTemplateViewModel().tags();

        let index = tags.findIndex(i => i.id === selectedTag.id);
        if (index == -1) {
            tags.push(selectedTag);
        }
        this.getTemplateViewModel().tags([])
        this.getTemplateViewModel().tags(tags);
        this.filterTags.clearInput();
    }

    public onClickDeleteTag(tag){

        let tags = this.getTemplateViewModel().tags();
        let index = tags.findIndex(i => i.id === tag.id);
        if(index != -1){
            tags.splice(index, 1);
        }
        this.getTemplateViewModel().tags([])
        this.getTemplateViewModel().tags(tags);
        this.filterTags.clearInput();
    }

    public setIsShownTagTypeSpec(bool : boolean){

        this.getTemplateViewModel().isShownTagTypeSpec(bool);
    }

    public onChangeStyle(value){

        // let oldValue = this.getTemplateViewModel().selectedStyle();
        // let tagType = this.filterTagType.getOptionObj();
        // let tags = this.getTemplateViewModel().tags();
        // let message = "Updating the style will clear any selected tag types, specification fields, and tags.  Are you sure you want to continue?";

        //update
        this.getTemplateViewModel().selectedStyle(value);

        // if(oldValue && (tagType || tags.length> 0 ) && !confirm(message)){
        //
        //     this.getTemplateViewModel().selectedStyle(oldValue);
        //     this.getTemplateViewModel().computedChosenStyle.notifySubscribers()
        //
        // }else{

            this.filterTagType.clearInput();
            this.filterTags.clearInput();
            this.setTagSpecs([]);
            this.setSelectedTagSpec(null);
            this.setTags([]);
            this.setIsShownTagTypeSpec(false);
        // }

        //update tooltip content
        this.selectTagTooltip.setContent(this.selectTagTooltipContent[this.getTemplateViewModel().selectedStyle()]);
        this.selectTagTooltip.getTemplateViewModel().visibleContent('');
        this.selectTagTooltip.hide();
    }

    public onChangeTagSpec(value){

        // let oldValue = this.getTemplateViewModel().selectedTagSpec();
        // let tags = this.getTemplateViewModel().tags();
        // let message = "Updating the specification field will clear any selected tags. Are you sure you want to continue?";

        //update
        this.getTemplateViewModel().selectedTagSpec(value);

        // if (tags.length > 0) {
        //
        //     if (oldValue && !confirm(message)) {
        //
        //         this.getTemplateViewModel().selectedTagSpec(oldValue);
        //         this.getTemplateViewModel().computedChosenTagSpec.notifySubscribers()
        //
        //     } else {

                this.filterTags.clearInput();
                this.setTags([]);
            // }
        // }
    }

    public setIsPublishingControl(value : boolean){
        this.getTemplateViewModel().isPublishingControl(value)
    }

    public setIsGlobalLockEnabled(value : boolean){
        this.getTemplateViewModel().isGlobalLockEnabled(value)
    }



}


// WEBPACK FOOTER //
// ./js/components/templates/articlePinnedTags_template.ts